import { ButtonERP, PrimeReactModal } from "@finanedi.es/storybook"
import { putTarjetaBancariaId } from "api/TarjetaBancaria.service"
import { STATUSCORRECT } from "common/components/ModalVerDocumento/constants"
import { MODAL_STYLES } from "constants/primereactStyles"
import { Form, Formik } from "formik"
import { InputText } from "primereact/inputtext"
import { useState } from "react"
import { useTranslation } from "react-i18next"

export interface ModalEditarTarjetasProps {
  data: {
    isOpen: boolean
    id: string | undefined
    logo?: {
      concepto?: string
      src: string
    } | null
    numero?: string | null
    nombre: string | undefined
  }
  onHide: () => void
  updateTable: () => void
}

export const ModalEditarTarjeta = ({
  data,
  onHide,
  updateTable,
}: ModalEditarTarjetasProps) => {
  const { t } = useTranslation()

  const [loading, setLoading] = useState(false)
  const initialValues = { nombre: data?.nombre ?? "", id: data.id }

  const handleSubmit = async (values: { nombre: string }) => {
    if (!data.id) return
    setLoading(true)
    const resp = await putTarjetaBancariaId({
      id: data.id,
      nombre: values.nombre,
    })
    if (resp.status === STATUSCORRECT) {
      updateTable()
      onHide()
    }
    setLoading(false)
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ values, setFieldValue, dirty }) => (
        <Form>
          <PrimeReactModal
            visible={data.isOpen}
            className='tw-w-auto !tw-text-sm tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
            baseZIndex={40}
            ptContext={MODAL_STYLES}
            closable={false}
            onHide={() => onHide()}
            closeOnEscape
            header={
              <div className='tw-flex tw-flex-row tw-items-center tw-gap-4'>
                <img
                  className={`${
                    data.logo?.src
                      ? "tw-h-10 tw-scale-150"
                      : "tw-w-auto tw-h-10 tw-object-contain"
                  }`}
                  src={data.logo?.src}
                  alt={`${t("bancos.cardsTable.editModal.labelImg")}${
                    data.logo?.concepto
                  }`}
                />
                <div className='tw-flex tw-flex-row tw-gap-2'>
                  <span className='tw-text-xl'>
                    {t("bancos.cardsTable.editModal.titleModal")}{" "}
                    {data.numero ?? ""}
                  </span>
                </div>
              </div>
            }
            footer={
              <div
                key='options'
                className='tw-flex tw-flex-row tw-justify-end tw-gap-3'
              >
                <ButtonERP
                  customize={{ size: "md", type: "white" }}
                  onClick={onHide}
                  label={`${t("bancos.cardsTable.editModal.cancelButton")}`}
                />
                <ButtonERP
                  customize={{ size: "md", type: "primary" }}
                  onClick={() => handleSubmit(values)}
                  loading={loading}
                  label={`${
                    loading
                      ? t("bancos.cardsTable.editModal.saveButton")
                      : t("bancos.cardsTable.editModal.confirmButton")
                  }`}
                  disabled={!dirty}
                />
              </div>
            }
          >
            <div className='tw-w-full tw-flex tw-flex-col tw-gap-1 tw-py-6'>
              <label htmlFor='nombre'>
                {t("bancos.cardsTable.editModal.nameLabel")}
              </label>
              <InputText
                className='tw-h-10 tw-col-span-2 !tw-text-sm !tw-border-neutral-25 hover:!tw-border-neutral-75'
                value={values.nombre}
                onChange={(e) => setFieldValue("nombre", e.target.value)}
              />
            </div>
          </PrimeReactModal>
        </Form>
      )}
    </Formik>
  )
}
